export function selectionIntersectsNode(node: Nullable<Element>): boolean {
    if (node == null) {
        return false;
    }
    const selection = window.getSelection();
    if (selection == null || selection.rangeCount === 0) {
        return false;
    }
    return selection.getRangeAt(0).intersectsNode(node);
}
